export default {"src":"/_next/static/media/FlagIcon.ed6c7a8e.svg","height":27,"width":19,"blurWidth":0,"blurHeight":0};